import { ChangeDetectorRef, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  constructor(
    private translateService: TranslateService // private cdref: ChangeDetectorRef
  ) {}

  init() {
    // this.translateService.addLangs(['en', 'fr', 'es']); // Add supported languages
    // this.translateService.setDefaultLang('en'); // Set default language
    // const browserLang = this.translateService.getBrowserLang();
    // this.translateService.use(
    //   browserLang.match(/en|fr|es/) ? browserLang : 'en'
    // );
    // this.cdref.detectChanges();
  }

  setLanguage(lang: string) {
    console.log('setLanguage', lang);
    this.translateService.use(lang);
  }
}
